/**
 * Detect Google Chrome (not Edge, Opera, or other Chromium forks).
 */
export function isChromeBrowser() {
  if (typeof navigator === 'undefined') return false;

  const brands = navigator.userAgentData?.brands;
  if (Array.isArray(brands)) {
    return brands.some((b) => b.brand === 'Google Chrome');
  }

  const ua = navigator.userAgent || '';
  return /Chrome\//i.test(ua) && !/Edg\//i.test(ua) && !/OPR\//i.test(ua);
}
